import { render } from "./reading.web.vue?vue&type=template&id=6af89f10&scoped=true&ts=true"
import script from "./reading.web.vue?vue&type=script&scoped=true&lang=ts"
export * from "./reading.web.vue?vue&type=script&scoped=true&lang=ts"

import "./reading.web.vue?vue&type=style&index=0&id=6af89f10&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af89f10"]])

export default __exports__